var _desc, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperienced(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    "aria-labelledby": titleId,
    "aria-describedby": "desc",
    role: "img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Diploma") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "A solid styled icon from Orion Icon Library.")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer2",
    d: "M53.5 20.8l-3.8-3.5 1-5.1-4.9-1.6-1.1-5-5.1.5-3.1-4.2L32 4.5l-4.5-2.6-3.1 4.2-5.1-.5-1.1 5-4.9 1.6 1 5.1-3.8 3.5 3 4.2-2.1 4.7 4.5 2.6v5.2l5.1.6 2.1 4.7 4.9-1.6 4 3.5 3.9-3.4 4.9 1.6 2.1-4.7 5.1-.6v-5.2l4.5-2.6-2-4.8zM32 33.3a10 10 0 1 1 10-10 10 10 0 0 1-10 10z",
    fill: "#8d8ea3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "layer1",
    d: "M27.2 45.8l-2.8.9-1.2.2a4 4 0 0 1-3.6-2.3L18.4 42l-2.4-.4-6 14.8 8.8-1.1 5.5 6.8 5-14.5zm18.4-4l-1.2 2.6a4 4 0 0 1-3.6 2.3l-1.2-.2-2.8-.9-2.1 1.9 5 14.5 5.5-6.8 8.8 1.2-6-14.8z",
    fill: "#253858"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienced);
export default __webpack_public_path__ + "static/media/Experienced.d1491dd9de367b4611f0c80021a27c68.svg";
export { ForwardRef as ReactComponent };